"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const acl_1 = require("./acl");
const roles_1 = __importDefault(require("./roles"));
/**
 * Determines if the user is a Super Admin
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 */
const isSuperAdmin = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.SUPER_ADMIN);
/**
 * Determines if the user is a Case Manager/Education Coordinator
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isCaseManager = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.CASE_MANAGER);
/**
 * Determines if the user is Operational Support
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isOperationalSupport = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.OPERATIONAL_SUPPORT);
/**
 * Determines if the user is a Strategist
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isStrategist = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.STRATEGIST);
/**
 * Determines if the user is a Student
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isStudent = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.STUDENT);
/**
 * Determines if the user is an External Student
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isExternalStudent = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.EXTERNAL_STUDENT);
/**
 * Determines if the user is a Tutor
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isTutor = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.TUTOR);
/**
 * Determines if the user is a Head Tutor
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isHeadTutor = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.HEAD_TUTOR);
/**
 * Determines if the user is in Accounts
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isAccounts = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.ACCOUNTS);
/**
 * Determines if the user is a System Operator
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isSystemOperator = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.SYSTEM_OPERATOR);
/**
 * Determines if the user is a Reviewer
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isReviewer = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.REVIEWER);
/**
 * Determines if the user is a Community User
 *   precated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isCommunityUser = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.COMMUNITY_USER);
/**
 * Determines if the user is a Community Admin
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isCommunityAdmin = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.COMMUNITY_ADMIN);
/**
 * Determines if the user is a Community Moderator
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isCommunityModerator = (userRoles) => acl_1.checkRole(userRoles, roles_1.default.COMMUNITY_MODERATOR);
/**
 * Determines if the user is an Admin
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * @param {string} userRoles User's roles to check.
 */
const isAdmin = (userRoles) => isSuperAdmin(userRoles) || isCaseManager(userRoles);
/**
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. isSuperAdmin(userRoles) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 */
exports.default = {
    isSuperAdmin,
    isCaseManager,
    isOperationalSupport,
    isStrategist,
    isStudent,
    isExternalStudent,
    isTutor,
    isHeadTutor,
    isAccounts,
    isAdmin,
    isSystemOperator,
    isReviewer,
    isCommunityUser,
    isCommunityAdmin,
    isCommunityModerator,
};
//# sourceMappingURL=roleUtils.js.map